import Icon from "./icon";



const DynamicIcon = ({onClick, name, size, color}) => {
  return (
    <div onClick={onClick} className={`${color} ${onClick ? 'cursor-pointer' : ''}`}>
        <Icon name={name} size={size} color='currentColor' />
    </div>
  );
};

export default DynamicIcon;
